import { AvatarWithFallback } from "@/components/ui/avatar.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Check } from "lucide-react";

/**
 * One account in a switchable list: avatar, name, provider, and a check on the
 * current entry. Shared by the home dropdown and Settings → Account so the two
 * surfaces render accounts identically.
 */
export const AccountRow = ({
  primary,
  secondary,
  avatarName,
  picture,
  isCurrent,
  disabled,
  action,
  onClick,
  statsigName,
}: {
  primary: string;
  secondary?: string;
  avatarName: string;
  picture?: string;
  isCurrent: boolean;
  disabled?: boolean;
  action?: React.ReactNode;
  onClick: () => void;
  statsigName: string;
}) => (
  // `variant="blank"` + `size="fit"` strip the pill chrome; the overrides below
  // restore the full-width row layout (same approach as Settings' ActionRow).
  <Button
    type="button"
    variant="blank"
    size="fit"
    onClick={onClick}
    disabled={disabled}
    data-statsig-name={statsigName}
    aria-current={isCurrent ? "true" : undefined}
    className="flex items-center justify-start gap-3 w-full rounded-lg px-2 py-2.5 text-sm font-normal whitespace-normal text-left hover:bg-secondary hover:text-secondary-foreground focus-visible:bg-secondary"
  >
    <AvatarWithFallback
      size="sm"
      className="border-0"
      person={{ name: avatarName, picture, value: primary }}
    />
    <div className="flex-1 min-w-0 text-left">
      <div className="flex items-center gap-1.5 truncate">
        <span className="truncate font-medium">{primary}</span>
        {isCurrent && <Check className="size-3.5 shrink-0 text-muted-foreground" />}
      </div>
      {secondary && <div className="truncate text-xs text-muted-foreground">{secondary}</div>}
    </div>
    {action}
  </Button>
);
